module.exports = __webpack_public_path__ + "img/calendar.ef0f5de8.svg";